import api from "app/lib/api";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

/**
 * Get selectors data for device groups
 * @returns {Promise}
 */
export const getDeviceGroupSelectors = async () => {
  const { data } = await api.get(endpoints.deviceGroups.selectors);

  return data;
};

/**
 * Get device groups
 *
 * @returns {Promise}
 */
export const getDeviceGroups = async () => {
  const { data } = await api.get(endpoints.deviceGroups.getAll);

  return data;
};

/**
 * Upsert device group
 *
 * @param {Object} payload
 * @param {string} isEditMode
 * @returns {Promise}
 */
export const upsertDeviceGroup = async (payload, isEditMode = false) => {
  const { _id: id, ...rest } = payload;

  let response;
  if (isEditMode) {
    const url = interpolate(endpoints.deviceGroups.getById, { id });
    response = await api.put(url, rest);
  } else {
    response = await api.post(endpoints.deviceGroups.getAll, rest);
  }

  return response?.data;
};

/**
 * Delete device group
 * @param {string} id
 * @returns {Promise}
 */
export const deleteDeviceGroup = async (id) => {
  const url = interpolate(endpoints.deviceGroups.getById, { id });

  const { data } = await api.delete(url);

  return data;
};
